export const ChangeNameController = ($scope,
                                        $mdDialog, name, callback, title, isUpperCase) => {
    "ngInject";

    $scope.name = name;
    $scope.callback = callback;
    $scope.title = title;
    $scope.isUpperCase = isUpperCase || false;
    // if json provided than clone configuration
    $scope.closeDialog = () => {
        $mdDialog.hide();
    };

    $scope.create = () => {
        $scope.callback($scope.name);
        $mdDialog.hide();
        document.onkeypress = () => {};
    };

    document.onkeypress = (ev) => {
        if (ev.key === "Enter") {
            if ($scope.name) {
                $scope.create();
            }
        }
    };
};



// WEBPACK FOOTER //
// ./sources/components/configurations/quick-setup/change-name/change-name.js